"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.simplifyFilterConfig = exports.isMembersFilterConfig = exports.getDefaultMembersFilterConfig = exports.getDefaultBaseFilterConfig = void 0;
const isEqual_js_1 = __importDefault(require("lodash-es/isEqual.js"));
const utils_js_1 = require("../../utils.js");
/**
 * Returns a default configuration for a base filter.
 *
 * @internal
 */
const getDefaultBaseFilterConfig = () => ({
    guid: (0, utils_js_1.guidFast)(13),
    disabled: false,
    locked: false,
});
exports.getDefaultBaseFilterConfig = getDefaultBaseFilterConfig;
/**
 * Returns a default configuration for a members filter.
 *
 * @internal
 */
const getDefaultMembersFilterConfig = () => (Object.assign(Object.assign({}, (0, exports.getDefaultBaseFilterConfig)()), { excludeMembers: false, enableMultiSelection: true, deactivatedMembers: [] }));
exports.getDefaultMembersFilterConfig = getDefaultMembersFilterConfig;
/**
 * Checks whether the given configuration is a members filter configuration.
 *
 * @param config - The filter configuration.
 * @returns Whether the configuration is a members filter configuration.
 * @internal
 */
function isMembersFilterConfig(config) {
    return 'excludeMembers' in config;
}
exports.isMembersFilterConfig = isMembersFilterConfig;
/**
 * Simplifies the filter configuration by removing default values.
 *
 * @param config - The filter configuration.
 * @returns The simplified filter configuration.
 * @internal
 */
const simplifyFilterConfig = (config) => {
    const defaultConfig = isMembersFilterConfig(config)
        ? (0, exports.getDefaultMembersFilterConfig)()
        : (0, exports.getDefaultBaseFilterConfig)();
    // Filter out properties that match their default values
    return Object.fromEntries(Object.entries(config).filter(([key, value]) => !(0, isEqual_js_1.default)(value, defaultConfig[key])));
};
exports.simplifyFilterConfig = simplifyFilterConfig;
